import { IComponentOptions } from 'angular';
import nvSdcModule from '../../../../nv.sdcModule.module';
import { GridColumnAutoCompleteCtrl } from './grid-column-autocomplete.controller';

export const GridColumnAutoCompleteComponent: IComponentOptions = {
  template: require('./grid-column-autocomplete.html'),
  bindings: {
    allSelectedCols: '=',
  },
  controller: GridColumnAutoCompleteCtrl,
};

angular.module(nvSdcModule).component('gridColumnAutoComplete', GridColumnAutoCompleteComponent);
